import type { MentionBaseProps } from '../mention-base';
import MentionBase from '../mention-base';

export interface MentionMessageProps extends MentionBaseProps {
  currentUserId: string | undefined;
  senderId: string;
  readerIds: string[];
  normal?: boolean;
}

export default function MentionMessage({
  user,
  currentUserId,
  senderId,
  readerIds,
  normal,
  ...props
}: MentionMessageProps) {
  const isSelf = useMemo(() => user?.user_id === currentUserId, [user?.user_id, currentUserId]);
  const isSender = useMemo(() => currentUserId === senderId, [currentUserId, senderId]);
  const isRead = useMemo(() => readerIds?.includes(user?.user_id), [user?.user_id, readerIds]);
  const isAtAll = useMemo(() => user?.user_id === '*', [user?.user_id]);

  const dot = useMemo(
    () =>
      isSelf || user?.user_id === '*' || !isSender ? undefined : isRead ? 'solid' : 'hollow',
    [isRead, isSelf, isSender, user?.user_id]
  );
  return (
    <MentionBase
      filled={isSelf}
      dot={dot}
      normal={normal}
      user={user}
      style={isAtAll ? { pointerEvents: 'none' } : undefined}
      {...props}
    ></MentionBase>
  );
}
